export var createEmptyWorksheet = function createEmptyWorksheet(_ref) {
  var maxCellAddress = _ref.maxCellAddress;
  return {
    maxCellAddress: maxCellAddress,
    activeCellAddress: {
      rowIndex: 0,
      columnIndex: 0
    },
    cellContents: []
  };
};